import { AppstoreAddOutlined, DeleteOutlined, DownOutlined, EditOutlined } from '@ant-design/icons';
import { Button, Dropdown, Menu, Space } from 'antd';
import { useTranslation } from 'react-i18next';
import { type UserlikeChatbotModuleSpecsFragment } from '../../../../api/fragments/UserlikeChatbotModuleSpecs';
import { type PermissionValues } from '../../../../utilities/hasPermissions';
import useDeleteModule from '../useDeleteModule';
import { useUpdateUserlikeChatbotModuleDrawer } from './UpdateUserlikeChatbotModuleDrawer';
import { useUserlikeChatbotSettingsDrawer } from './UserlikeChatbotSettingsDrawer';

export type UserlikeChatbotModuleActionsProps = {
    module: UserlikeChatbotModuleSpecsFragment;
    permissions: Pick<PermissionValues, 'hasDeletePermission' | 'hasUpdatePermission'>;
};

const UserlikeChatbotModuleActions = ({ module, permissions }: UserlikeChatbotModuleActionsProps) => {
    const { t } = useTranslation(['userlikeChatbotModuleDetails', 'moduleDetails']);
    const drawer = useUserlikeChatbotSettingsDrawer(module.id);
    const updateUserlikeChatbotModuleDrawer = useUpdateUserlikeChatbotModuleDrawer(module);
    const deleteModule = useDeleteModule(module.id);
    const { hasUpdatePermission, hasDeletePermission } = permissions;

    const items = [
        hasUpdatePermission && {
            label: t('userlikeChatbotModuleDetails:mainActionButtons.updateSpecs'),
            key: 'updateSpecs',
            icon: <EditOutlined />,
            onClick: updateUserlikeChatbotModuleDrawer.open,
        },
        hasUpdatePermission && {
            label: t('userlikeChatbotModuleDetails:mainActionButtons.addSetting'),
            key: 'addSetting',
            icon: <AppstoreAddOutlined />,
            onClick: drawer.open,
        },
        hasDeletePermission && {
            label: t('userlikeChatbotModuleDetails:mainActionButtons.delete'),
            key: 'delete',
            icon: <DeleteOutlined />,
            onClick: deleteModule,
            danger: true,
        },
    ].filter(Boolean);

    if (!items.length) {
        return null;
    }

    return (
        <>
            <Dropdown overlay={<Menu items={items} />}>
                <Button type="primary">
                    <Space>
                        <span>{t('userlikeChatbotModuleDetails:mainActionButtons.actions')}</span>
                        <DownOutlined />
                    </Space>
                </Button>
            </Dropdown>
            {drawer.render()}
            {updateUserlikeChatbotModuleDrawer.render()}
        </>
    );
};

export default UserlikeChatbotModuleActions;
